import React, { useState } from "react";
import search from "../images/searchicon.png";

const Search = ({ handleSearchText, searchText, filterBy, handleFilterClick }) => {

    const [openSearch, setOpenSearch] = useState(true)

    const handleOpenSearch = () => {
        setOpenSearch(openSearch => !openSearch)
    }
    return(
    <>
        <button id="filterbutton" onClick={handleOpenSearch}>Filter {openSearch ? "X":">"}</button>
        <div id="secondnav" className={openSearch ? "on" : null}>
          <div className="secondnavcontainer">
            <div className="secondnavleft">
                <button value="All" className={filterBy === "All"? "active":null} onClick={handleFilterClick} id="inputbutton">All</button>
                <button value="Cityscape" className={filterBy === "Cityscape"? "active":null} onClick={handleFilterClick} id="inputbutton">Cityscape</button>
                <button value="Landscape" className={filterBy === "Landscape"? "active":null} onClick={handleFilterClick} id="inputbutton">Landscape</button>
                <button value="Street" className={filterBy === "Street"? "active":null} onClick={handleFilterClick} id="inputbutton">Street</button>
                <button value="Nature" className={filterBy === "Nature"? "active":null} onClick={handleFilterClick} id="inputbutton">Nature</button>
                <button value="Sport" className={filterBy === "Sport"? "active":null} onClick={handleFilterClick} id="inputbutton">Sport</button>
                <button value="Portrait" className={filterBy === "Portrait"? "active":null} onClick={handleFilterClick} id="inputbutton">Portrait</button>
                <button value="Wildlife" className={filterBy === "Wildlife"? "active":null} onClick={handleFilterClick} id="inputbutton">Wildlife</button>
                <button value="Food" className={filterBy === "Food"? "active":null} onClick={handleFilterClick} id="inputbutton">Food</button>
                <button value="Others" className={filterBy === "Others"? "active":null} onClick={handleFilterClick} id="inputbutton">Others</button>
            </div>
            <div className="secondnavright">
                <img src={search} id="search-icon" alt="search-icon"/>
                <form>
                    <input type="text" maxLength="20" value={searchText} onChange={handleSearchText} placeholder="Search camera..."/>
                </form>
            </div>
          </div>
        </div>
    </>
    )
}

export default Search;